module.exports = __webpack_public_path__ + "static/img/ca.229a3d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shipIcons/mipmap-xxxhdpi/ca.png
// module id = 3eBB
// module chunks = 18